import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import {
  ApiService,
  ESearchBlockPath,
  ETireDecInc,
  IAllData,
  IApiRequestContactBody,
  IApiRequestGalleryLikeBody,
  IApiResponseAll,
  IBranchDetails,
  IBranchSearchOptions,
  IGalleryData,
  INewsData,
  IOption,
  IProductData,
  IProductId,
  IProductSearchOptions,
  IPromotionData,
  ISearchBlockOptions,
  ITireDecIncRequire,
  IVideoData,
} from './api.service';
import {
  banners,
  branchData,
  branchList,
  branchListByLocation,
  branchListByName,
  dataSearchBlock,
  menuMock,
  newsData,
  newsList,
  popups,
  productBrandList,
  productCategoryList,
  productData,
  productIdData,
  promotionData,
  promotionList,
  videoData,
  videoList,
} from '../models/dataModel';
import { IPaging } from '../models/promoWebInterface';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({ providedIn: 'root' })
export class MockApiService extends ApiService {
  private readonly loggingService = inject(LoggingService);

  // SECTION: GET

  // SECTION: PRODUCTS
  //#region
  // NOTE: GET AllProduct
  getAllProduct(): Observable<IAllData> {
    return of(productBrandList).pipe(
      tap((res) => this.loggingService.warn('GET | getAllProduct[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET AllProductCategory
  getAllProductCategory(
    visibility: string,
    category: string,
    options: IProductSearchOptions = {},
    paging: IPaging = { cur: 1, per: 20 }
  ): Observable<IAllData> {
    this.loggingService.warn(
      '[GET] | getAllProductCategory[MOCK] visibility:',
      visibility,
      'category :',
      category,
      'options :',
      options,
      'paging :',
      paging
    );
    return of(productCategoryList).pipe(
      tap((res) => this.loggingService.warn('GET | getAllProductCategory[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  getProductTable(visibility: string, category: string, options: IProductSearchOptions = {}): Observable<IAllData> {
    return of();
  }
  // NOTE: GET ProductById
  getProductById(visibility: string, id: number): Observable<IProductData> {
    this.loggingService.warn('[GET] | getProductById[MOCK] visibility:', visibility, 'id :', id);
    return of(productData).pipe(
      tap((res) => this.loggingService.warn('GET | getProductById[MOCK] :', res)),
      map((res) => res.data as IProductData),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET TireDecInc
  getTireDecInc(visibility: string, options: ETireDecInc, preq: ITireDecIncRequire): Observable<IProductId> {
    this.loggingService.warn(
      '[GET] | getTireDecInc[MOCK] visibility:',
      visibility,
      'options :',
      options,
      'preq :',
      preq
    );
    return of(productIdData).pipe(
      tap((res) => this.loggingService.warn('GET | getTireDecInc[MOCK] :', res)),
      map((res) => res.data as IProductId),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getTireSelectedUpDown(size: string, brand: number, model: string): Observable<IProductId> {
    this.loggingService.warn('[GET] | getTireSelectedUpDown[MOCK] size:', size, 'brand :', brand, 'model :', model);
    return of(productIdData).pipe(
      tap((res) => this.loggingService.warn('GET | getTireSelectedUpDown[MOCK] :', res)),
      map((res) => res.data as IProductId),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getChangeTire(preq: ITireDecIncRequire, onChange: string) {
    return of(productIdData).pipe(
      tap((res) => this.loggingService.warn('GET | getChangeTire[MOCK] :', res)),
      map((res) => res.data as IProductId),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET DataSearchBlock
  getDataSearchBlock(
    category: string,
    input: ESearchBlockPath,
    visibility: string,
    options: ISearchBlockOptions
  ): Observable<any> {
    this.loggingService.warn(
      '[GET] | getDataSearchBlock[MOCK] category:',
      category,
      'input :',
      input,
      'visibility :',
      visibility,
      'options',
      options
    );
    return of(dataSearchBlock).pipe(
      tap((res) => this.loggingService.warn('GET | DataSearchBlock[MOCK] :', res)),
      map((res: any) => res.data.rows),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: BANNERS
  //#region
  // NOTE: GET AllBanner
  getAllBanner(visibility: string): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllBanner[MOCK] visibility:', visibility);
    return of(banners).pipe(
      tap((res) => this.loggingService.warn('GET | getAllBanner[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: POPUPS
  //#region
  // NOTE: GET AllPopups
  getAllPopup(visibility: string): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllPopup[MOCK] visibility:', visibility);
    return of(popups).pipe(
      tap((res) => this.loggingService.warn('GET | getAllPopup[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: PROMOTIONS
  //#region
  // NOTE: GET AllPromotion
  getAllPromotion(visibility: string, paging: IPaging): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllPromotion[MOCK] visibility:', visibility, 'paging :', paging);
    return of(promotionList).pipe(
      tap((res) => this.loggingService.warn('GET | getAllPromotion[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET Promotion
  getPromotionById(id: number): Observable<IPromotionData> {
    this.loggingService.warn('[GET] | getPromotionById[MOCK] id:', id);
    return of(promotionData).pipe(
      tap((res) => this.loggingService.warn('GET | getPromotionById[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: NEWS
  //#region
  // NOTE: GET AllNews
  getAllNews(visibility: string, paging: IPaging): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllNews[MOCK] visibility:', visibility, 'paging :', paging);
    return of(newsList).pipe(
      tap((res) => this.loggingService.warn('GET | getAllNews[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET News
  getNewsById(id: number): Observable<INewsData> {
    this.loggingService.warn('[GET] | getNewsById[MOCK] id:', id);
    return of(newsData).pipe(
      tap((res) => this.loggingService.warn('GET | getNewsById[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  getAllArticle(visibility: string, paging: IPaging): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllNews[MOCK] visibility:', visibility, 'paging :', paging);
    return of(newsList).pipe(
      tap((res) => this.loggingService.warn('GET |getAllArticle[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET News
  getArticleById(id: number): Observable<INewsData> {
    this.loggingService.warn('[GET] | getNewsById[MOCK] id:', id);
    return of(newsData).pipe(
      tap((res) => this.loggingService.warn('GET | getArticleById[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: VIDEO
  //#region
  // NOTE: GET AllVideo
  getAllVideo(visibility: string, paging: IPaging): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllVideo[MOCK] visibility:', visibility, 'paging :', paging);
    return of(videoList).pipe(
      tap((res) => this.loggingService.warn('GET | getAllVideo[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET VideoById
  getVideoById(id: number): Observable<IVideoData> {
    this.loggingService.warn('[GET] | getVideo[MOCK] id:', id);
    return of(videoData).pipe(
      tap((res) => this.loggingService.warn('GET | getVideoById[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //

  // SECTION: CENTER_SERVICE
  //#region
  // NOTE: GET CenterList
  getAllCenter(): Observable<IApiResponseAll> {
    return of();
  }
  //#endregion
  // !SECTION //  // !SECTION //

  // SECTION: BRANCH
  //#region
  // NOTE: GET AllBranch
  getAllBranch(visibility: string, options: IBranchSearchOptions = {}, paging: IPaging): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllBranch[MOCK] visibility:', visibility, 'paging :', paging);
    return of(branchList).pipe(
      tap((res) => this.loggingService.warn('GET | getAllBranch[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET BranchById
  getBranchById(visibility: string, id: number): Observable<IBranchDetails> {
    this.loggingService.warn('[GET] | getBranchById[MOCK] visibility:', visibility, 'id :', id);
    return of(branchData).pipe(
      tap((res) => this.loggingService.warn('GET | getBranchById[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET BranchByName
  getBranchByName(
    visibility: string,
    options: IBranchSearchOptions = {},

    paging: IPaging = { cur: 1, per: 9 }
  ): Observable<IAllData> {
    this.loggingService.warn('[GET] | getBranchByName[MOCK] visibility:', visibility, 'name :', name);
    return of(branchListByName).pipe(
      tap((res) => this.loggingService.warn('GET | getBranchByName[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: GET BranchByCurrentLocation
  getBranchByCurrentLocation(visibility: string, lat: number, lng: number): Observable<IAllData> {
    this.loggingService.warn(
      '[GET] | getBranchByCurrentLocation[MOCK] visibility:',
      visibility,
      'lat :',
      lat,
      'lng :',
      lng
    );
    return of(branchListByLocation).pipe(
      tap((res) => this.loggingService.warn('GET | getBranchByCurrentLocation[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  // !SECTION //
  // !SECTION //

  ////////////////////////////////////////////

  // SECTION: POST

  // SECTION: CONTACT
  // NOTE: POST Contact
  postContact(body: IApiRequestContactBody) {
    this.loggingService.warn('[GET] | getBranchByCurrentLocation[MOCK] body:', body);
    return of([]);
  }

  // NOTE: POST Gallery Like
  postGalleryLike(
    galleryId: number,
    ipAddress: string
  ): Observable<{ success: boolean; like_count: number; like_status: number }> {
    this.loggingService.warn('[POST] | postGalleryLike[MOCK] galleryId:', galleryId, 'ipAddress:', ipAddress);

    // Mock response - simulate like toggle
    const mockResponse = {
      success: true,
      like_count: Math.floor(Math.random() * 100) + 1, // Random like count for demo
      like_status: Math.random() > 0.5 ? 1 : 0, // Random like status (1 = liked, 0 = not liked)
    };

    return of(mockResponse).pipe(tap((res) => this.loggingService.warn('POST | postGalleryLike[MOCK] :', res)));
  }

  // !SECTION //
  //NOTE - POST GALLERY LIKE V2
  postGalleryLikeV2(body: IApiRequestGalleryLikeBody) {
    this.loggingService.warn('[POST] | postGalleryLikeV2[MOCK] body:', body);
    return of([]);
  }
  getMenuProduct(visibility: string) {
    this.loggingService.warn('[GET] | getBranchByCurrentLocation[MOCK] visibility:', visibility, 'lat :');
    return of(menuMock).pipe(
      tap((res) => this.loggingService.warn('GET | getBranchByCurrentLocation[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }

  getSubMenuTire(visibility: string, brandId?: string) {
    return of();
  }
  getSubMenuBrandTire(visibility: string) {
    return of();
  }
  getSubMenuIDTire(visibility: string, name: string, brand?: any) {
    return of();
  }

  getSubMenuModelTire(visibility: string, category: string, input: ESearchBlockPath, options: IProductSearchOptions) {
    return of();
  }
  getHighlightsFilter(visibility: string) {
    return of();
  }
  getTypesFilter(visibility: string) {
    return of();
  }
  // !SECTION //

  // !SECTION //
  getAllGallery(visibility: string, options?: IOption): Observable<IAllData> {
    this.loggingService.warn('[GET] | getAllGallery[MOCK] visibility:', visibility, 'options :', options);
    return of(newsList).pipe(
      tap((res) => this.loggingService.warn('GET |getAllGallery[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: GET GalleryById
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getGalleryById(id: number, ip: string): Observable<IGalleryData> {
    this.loggingService.warn('[GET] | getGalleryById[MOCK] id:', id);
    return of(newsData).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryById[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  ///NOTE - GET CarOptions
  getGalleryCarOptions(): Observable<any> {
    this.loggingService.warn('[GET] | getGalleryCarOptions[MOCK]');
    return of({
      ok: 1,
      status: 1,
      data: {
        rows: [
          {
            id: 1,
            name: 'Honda',
          },
          {
            id: 3,
            name: 'Toyota',
          },
        ],
      },
      msg: 'get data is success',
    }).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryCarOptions[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  ///NOTE - GET CarModelOptions
  getGalleryCarModelOptions(brandId?: number): Observable<any> {
    this.loggingService.warn('[GET] | getGalleryCarModelOptions[MOCK] brandId:', brandId);
    return of({
      ok: 1,
      status: 1,
      data: {
        rows: [
          {
            id: 3,
            name: 'City 2023',
          },
          {
            id: 2,
            name: 'City 2025',
          },
        ],
      },
      msg: 'get data is success',
    }).pipe(
      tap((res) => this.loggingService.warn('GET | getGalleryCarModelOptions[MOCK]:', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getGalleryTireModelOptions(visibility: string, id?: number): Observable<any> {
    this.loggingService.warn('[GET] | getGalleryTireModelOptions[MOCK] visibility:', visibility);
    return of({
      ok: 1,
      status: 1,
      data: {
        rows: [
          {
            name: 'NANOENERGY R38',
          },
          {
            name: 'NT420S',
          },
        ],
      },
      msg: 'get data is success',
    }).pipe(
      tap((res) => this.loggingService.warn('GET |getGalleryTireModelOptions[MOCK]:', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  getGalleryTireBrandOptions(): Observable<any> {
    {
      this.loggingService.warn('[GET] | getGalleryTireBrandOptions[MOCK]');
      return of({
        ok: 1,
        status: 1,
        data: {
          rows: [
            {
              id: 1,
              name: 'Toyo Tires',
            },
            {
              id: 2,
              name: 'Nitto Tires',
            },
          ],
        },
        msg: 'get data is success',
      }).pipe(
        tap((res) => this.loggingService.warn('GET | getGalleryTireBrandOptions[MOCK]:', res)),
        map((res: any) => res.data),
        catchError((error) => {
          this.loggingService.error(error);
          return throwError(() => error);
        })
      );
    }
  }
}
